function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { Button, ConfirmationModal, PasswordField, TextButton, Typography } from 'seagull';
import styles from "./SecureLoginModal.module.scss";
import { useStore, useStoreActions } from "../../store/store-context";
import { Controller, useForm } from 'react-hook-form';
import IntuitButton from "../IntuitButton/IntuitButton";
import GoogleButton from "../GoogleButton/GoogleButton";
import { useHistory } from 'react-router-dom';
import { useEventReporter } from "../../event-reporter";
import { routes } from "../../constants";
export const SecureLoginModal = _ref => {
  let {
    dismissModal
  } = _ref;
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    reportToHeap
  } = useEventReporter();
  const [step, setStep] = useState('selectIdentity');
  const form = useForm({
    mode: 'all',
    defaultValues: {
      password: '',
      ['confirm-password']: ''
    }
  });
  const {
    handleSubmit
  } = form;
  const setPassword = async data => {
    logBI(18102);
    reportToHeap('secure-login', 'click', 'client-click-set-login-password');
    const {
      password
    } = data;
    await api.auth.editUserDetails({
      password
    });
    dismissModal(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "secure-login-modal"
  }, step === 'selectIdentity' && /*#__PURE__*/React.createElement(SelectIdentityTypeStep, {
    dismissModal: dismissModal,
    onCreatePassword: () => {
      setStep('setPassword');
    }
  }), step === 'setPassword' && /*#__PURE__*/React.createElement(SetPasswordStep, {
    dismissModal: dismissModal,
    onClickBack: () => setStep('selectIdentity'),
    onContinue: handleSubmit(setPassword),
    form: form
  }));
};
const SelectIdentityTypeStep = _ref2 => {
  let {
    onCreatePassword,
    dismissModal
  } = _ref2;
  const userInfo = useStore(state => state.userInfo);
  const history = useHistory();
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Secure login required",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.textContainer
    }, /*#__PURE__*/React.createElement(Typography, null, "Creating a Service Provider account requires a secure authentication method. Choose from the following options:")), /*#__PURE__*/React.createElement("div", {
      className: styles.formContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.formComponentsWrapper
    }, /*#__PURE__*/React.createElement(Button, {
      skin: "darkSecondary",
      size: "medium",
      fluid: true,
      "data-testid": "create-password-btn",
      onClick: onCreatePassword
    }, "Create a password"), /*#__PURE__*/React.createElement(GoogleButton, {
      ensureEmail: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email(),
      onAuthSuccess: () => {
        history.push(routes.home);
      }
    }), /*#__PURE__*/React.createElement(IntuitButton, {
      ensureEmail: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email()
    })))),
    secondaryButtonLabel: "Cancel",
    secondaryButtonTestid: "cancel-btn",
    onSecondaryButtonClick: () => dismissModal(false),
    onCloseButtonClick: () => dismissModal(false),
    "data-testid": "select-identity-step"
  });
};
const SetPasswordStep = _ref3 => {
  let {
    onClickBack,
    onContinue,
    form,
    dismissModal
  } = _ref3;
  const {
    control,
    getValues
  } = form;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Set your password",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement(TextButton, {
      underline: "none",
      "data-testid": "back-btn",
      onClick: onClickBack
    }, '< Back'), /*#__PURE__*/React.createElement("div", {
      className: styles.formContainer
    }, /*#__PURE__*/React.createElement("form", {
      className: styles.formComponentsWrapper
    }, /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "password",
      defaultValue: "",
      rules: {
        required: true,
        minLength: {
          value: 10,
          message: 'Use 10 or more characters'
        },
        deps: 'confirm-password'
      },
      render: _ref4 => {
        var _fieldState$error;
        let {
          field,
          fieldState
        } = _ref4;
        return /*#__PURE__*/React.createElement(PasswordField, _extends({}, field, {
          error: !!fieldState.error,
          helperText: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
          "data-testid": "password",
          label: "Password"
        }));
      }
    }), /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "confirm-password",
      defaultValue: "",
      rules: {
        required: true,
        validate: value => {
          const doPasswordsMatch = getValues('password') === value;
          return doPasswordsMatch || 'Passwords do not match';
        }
      },
      render: _ref5 => {
        var _fieldState$error2;
        let {
          field,
          fieldState
        } = _ref5;
        return /*#__PURE__*/React.createElement(PasswordField, _extends({}, field, {
          error: !!fieldState.error,
          helperText: (_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message,
          "data-testid": "confirm-password",
          label: "Re-enter password"
        }));
      }
    })))),
    primaryButtonLabel: "Continue",
    primaryButtonTestid: "continue-btn",
    onPrimaryButtonClick: onContinue,
    secondaryButtonLabel: "Cancel",
    secondaryButtonTestid: "cancel-btn",
    onSecondaryButtonClick: () => dismissModal(false),
    onCloseButtonClick: () => dismissModal(false),
    "data-testid": "set-password-step"
  });
};